import Types from 'types/types'

/**
 * List of Columns
 * @type {import('types/column').Column[]}
 * @readonly
 */
const commercialInformationColumns = [
    {
        fieldName: 'OperationManager',
        name: 'CR',
        type: Types.STRING,
        onRender: item => `${item['createdByUser.lastname'] || ''} ${item['createdByUser.firstname'] || ''}`,
    },
    {
        fieldName: 'Consultant',
        name: 'Consultant',
        type: Types.STRING,
        onRender: item => `${item['consultant.lastname'] || ''} ${item['consultant.firstname'] || ''}`,
    },
    {
        fieldName: 'client.name',
        name: 'Présent dans ATS',
        type: Types.STRING,
        onRender: item => (item.prospectName ? '' : item['client.name']),
    },
    {
        fieldName: 'prospectName',
        name: 'Non présent dans ATS',
        type: Types.STRING,
    },
    {
        fieldName: 'department.name',
        name: 'Département',
        type: Types.STRING,
    },
    {
        fieldName: 'Contact',
        name: 'Nom/Prénom',
        type: Types.STRING,
        onRender: item => `${item.contactLastname || ''} ${item.contactFirstname || ''}`,
    },
    {
        fieldName: 'contactPhone',
        name: 'Téléphone',
        type: Types.STRING,
    },
    {
        fieldName: 'contactFunction',
        name: 'Fonction',
        type: Types.STRING,
        onRender: item => item.contactFunction || item['contactMetier.name'] || '',

    },
    {
        fieldName: 'comment',
        name: 'Commentaire',
        type: Types.STRING,
    },
    {
        fieldName: 'rdvDate',
        name: 'Entretien',
        type: Types.DATE,
    },
    {
        fieldName: 'isAccepted',
        name: 'Accepté ?',
        type: Types.BOOLEAN,
    },
]

/**
 * List of Columns
 * @type {import('types/column').Column[]}
 * @readonly
 */
export const commercialInformationColumnsWithoutCR = commercialInformationColumns.filter(col => col.fieldName !== 'OperationManager')
export const commercialInformationColumnsWithoutConsultant = commercialInformationColumns.filter(col => col.fieldName !== 'Consultant')

export default commercialInformationColumns
